import React from 'react';
import {useIntl} from 'react-intl'
import {trans} from '../../core/utils/translationUtil'
import {injectIntl} from "react-intl";

let Text = ({text, intl}) => trans(intl, text)

export default injectIntl(Text)